import { render, staticRenderFns } from "./QuizTimer.vue?vue&type=template&id=40f1ffb4&scoped=true"
import script from "./QuizTimer.vue?vue&type=script&lang=js"
export * from "./QuizTimer.vue?vue&type=script&lang=js"
import style0 from "./QuizTimer.vue?vue&type=style&index=0&id=40f1ffb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1ffb4",
  null
  
)

export default component.exports